import { FC } from "react";
import { Box } from "@mui/material";
import { COLOR_CONSTANTS } from "src/domains/shared/constants/styles";
import { HOVER_SURFACE, LineGlyph, LineGlyphName, REDUCED_MOTION_SX } from "src/domains/shared/components/StateTransition";

interface SideMenuItemProps {
  label: string;
  icon: LineGlyphName;
  /** 클릭 · Enter · Space 로 실행할 동작(메뉴 전환, 로그아웃 등). */
  onSelect: () => void;
  /**
   * 선택 상태를 갖는 메뉴 항목에만 지정한다.
   * 지정하지 않으면(로그아웃처럼 선택 대상이 아닌 항목) `aria-current` 를 출력하지 않는다.
   */
  isActive?: boolean;
}

/** 마이페이지 왼쪽 메뉴의 항목 한 줄 — 아이콘 16 + 13px 라벨, 높이 36px. */
export const SideMenuItem: FC<SideMenuItemProps> = ({ label, icon, onSelect, isActive }) => (
  <Box
    component="button"
    type="button"
    aria-current={isActive ? "page" : undefined}
    onClick={onSelect}
    sx={{
      height: 36,
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "0 10px",
      border: 0,
      borderRadius: "6px",
      fontFamily: "inherit",
      fontSize: 13,
      fontWeight: isActive ? 600 : 500,
      textAlign: "left",
      cursor: "pointer",
      color: isActive ? COLOR_CONSTANTS.primary.main : COLOR_CONSTANTS.text.primary,
      backgroundColor: isActive ? COLOR_CONSTANTS.primary._states.selected : "transparent",
      transition: "background-color 120ms ease, color 120ms ease",
      "&:hover": {
        backgroundColor: isActive ? COLOR_CONSTANTS.primary._states.selected : HOVER_SURFACE,
      },
      "&:focus-visible": {
        outline: "none",
        boxShadow: `0 0 0 2px ${COLOR_CONSTANTS.primary._states.focusVisible}`,
      },
      ...REDUCED_MOTION_SX,
    }}
  >
    <LineGlyph name={icon} />
    {label}
  </Box>
);
